let useIcons: boolean = true;

export const Icons = {
    get success() {
        return useIcons ? '✅' : '[SUCCESS]';
    },
    get success_outline() {
        return useIcons ? '☑️' : '[SUCCESS]';
    },
    get info() {
        return useIcons ? 'ℹ️' : '[INFO]';
    },
    get warning() {
        return useIcons ? '⚠️' : '[WARNING]';
    },
    get error() {
        return useIcons ? '❌' : '[ERROR]';
    },
    get loading() {
        return useIcons ? '⌛' : '[LOADING]';
    },
    get sparkle() {
        return useIcons ? '✨' : '[SUCCESS]';
    },
    setUse(value: boolean) {
        useIcons = value;
    },
    getUse(): boolean {
        return useIcons;
    }
};
